import { AGENT_TASK_TRANSFER_FAILURE } from 'lib/common/constants/connectExceptions';

import { getAgentConnection } from 'lib/common/utils/conferenceConnections';
import connectGetter from 'lib/common/utils/connectGetter';
import toast from 'lib/common/utils/toast';

import { TIME_TO_WAIT_FOR_TRANSFER_FAIL_MS } from '../constants/timeToWaitForTransferFailMS';
import waitForContactEnded from './waitForContactEnded';

export default function waitForAsyncTaskTransfer(contact: connect.Contact) {
  return new Promise(async (resolve, reject) => {
    const agentConnection = getAgentConnection(contact);
    const taskSession = await connectGetter(agentConnection, 'getMediaController');

    if (taskSession) {
      taskSession.onTransferFailed?.((message) => {
        toast('error', AGENT_TASK_TRANSFER_FAILURE);
        reject(message);
      });

      // Sometimes can take over 5 seconds for agent task transfers to fail, so wait for at least 5 seconds before
      // continuing as success (i.e. no transfer failed cb)
      await new Promise((resolve) => setTimeout(resolve, TIME_TO_WAIT_FOR_TRANSFER_FAIL_MS));
    }

    await waitForContactEnded(contact);

    resolve(undefined);
  });
}
